import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { getCache } from '../utils/cache';
import { FinxAiUser } from '../models/finxaiUser';
import logger from '../utils/logger';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const savedUser = getCache("loggedInUser") as FinxAiUser | null;

  if (!savedUser) {
    logger.debug("User not authenticated, redirecting to login");
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};